import { jsx } from 'react/jsx-runtime';

const SvgFormCheckCircle = (props) => jsx("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 24 24", height: props.size, width: props.size }, props, { children: jsx("path", { fill: "#2D2E2E", d: "M12 22a10 10 0 1 0 0-20 10 10 0 0 0 0 20ZM8.21 10.79l2.79 2.8 5.29-5.3 1.42 1.42-6.71 6.7-4.21-4.2 1.42-1.42Z" }) }));

export { SvgFormCheckCircle as default };
//# sourceMappingURL=FormCheckCircle.es.js.map
